import React from "react";
import comingSoon from "../../AnimatedIcons/comingSoon.json";
import Lottie from "lottie-react";
import useTitle from "../../Hooks/useTitle";

const Blog = () => {
  useTitle("Blogs");
  return (
    <div className="bg-primary h-screen flex justify-center">
      <Lottie animationData={comingSoon} className="w-96"></Lottie>
    </div>
  );
};

export default Blog;
